import styles from '../styles/Teach.module.scss';
import React, {useEffect, useRef, useState} from "react";
import Button from "./Button";
import PCButton from "./PCButton";
import MessageBubble from "./MessageBubble";
import {TeachBlockPage, WelcomeStep} from "../services/types";
const base = process.env.PUBLIC_URL || ``;

interface TeachProps {
    pages: TeachBlockPage[];
    onClick: () => void;
}


const Teach: React.FC<TeachProps> = ({pages, onClick}) =>  {
    const [teachPage, setTeachPage] = useState<number>(0);
    const [q1color, setQ1color] = useState<string>('rgba(69, 91, 193, 1)');
    const [q2color, setQ2color] = useState<string>('rgba(69, 91, 193, 1)');
    const [q3color, setQ3color] = useState<string>('rgba(69, 91, 193, 1)');
    const [qAnswered, setQAnswered] = useState<boolean>(false);

    const analyzeTableScrollRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scrollEl = analyzeTableScrollRef.current;
        if (!scrollEl) return;

        let isDown = false;
        let startX: number;
        let scrollLeft: number;

        const mouseDownHandler = (e: MouseEvent) => {
            isDown = true;
            scrollEl.classList.add(styles.activeDrag); // (опционально, для курсора)
            startX = e.pageX - scrollEl.offsetLeft;
            scrollLeft = scrollEl.scrollLeft;
        };

        const mouseLeaveHandler = () => {
            isDown = false;
            scrollEl.classList.remove(styles.activeDrag);
        };

        const mouseUpHandler = () => {
            isDown = false;
            scrollEl.classList.remove(styles.activeDrag);
        };

        const mouseMoveHandler = (e: MouseEvent) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - scrollEl.offsetLeft;
            const walk = (x - startX) * 1; // Скорость прокрутки
            scrollEl.scrollLeft = scrollLeft - walk;
        };

        scrollEl.addEventListener('mousedown', mouseDownHandler);
        scrollEl.addEventListener('mouseleave', mouseLeaveHandler);
        scrollEl.addEventListener('mouseup', mouseUpHandler);
        scrollEl.addEventListener('mousemove', mouseMoveHandler);

        return () => {
            scrollEl.removeEventListener('mousedown', mouseDownHandler);
            scrollEl.removeEventListener('mouseleave', mouseLeaveHandler);
            scrollEl.removeEventListener('mouseup', mouseUpHandler);
            scrollEl.removeEventListener('mousemove', mouseMoveHandler);
        };
    }, [teachPage]);

    const handlePrevClick = () => {
        const scrollEl = analyzeTableScrollRef.current;
        scrollEl!.scrollTo(0, 0)
        if (teachPage === 0){
            setTeachPage(pages.length - 1)
        }else {
            setTeachPage(teachPage - 1)
        }
    }
    const handleNextClick = () => {
        const scrollEl = analyzeTableScrollRef.current;
        scrollEl!.scrollTo(0, 0)
        if (teachPage === pages.length - 1){
            setTeachPage(0)
        }else {
            setTeachPage(teachPage + 1)
        }
    }

    const handleQClick = (item:number) => {
        if (qAnswered) {
            return false;
        }
        setQAnswered(true)
        if (item === 1){
            setQ1color('rgba(206, 17, 17, 1)')
            setQ2color('rgba(153, 153, 153, 1)')
            setQ3color('rgba(153, 153, 153, 1)')
        }
        if (item === 2){
            setQ1color('rgba(153, 153, 153, 1)')
            setQ2color('rgba(65, 149, 31, 1)')
            setQ3color('rgba(153, 153, 153, 1)')
        }
        if (item === 3){
            setQ1color('rgba(153, 153, 153, 1)')
            setQ2color('rgba(153, 153, 153, 1)')
            setQ3color('rgba(206, 17, 17, 1)')
        }
    }


    return (
        <>
            <div className={styles.Container}>
                <div className={styles.TeachImageContainer} id="scrollContainer" ref={analyzeTableScrollRef}
                     style={{
                         // ...(teachPage === pages.length - 1 && {marginTop: '60px'})
                     }}
                >
                    <div className={styles.TeachImageContainerImages}>
                        <img src={pages[teachPage].image} className={styles.teachImage} alt="teachImage" />
                        {pages[teachPage].image == `${base}/images/alexey_teach2_1.png` &&
                            <>
                                <div className={styles.teachQuestion}>
                                    <div className={styles.teachQuestionItem} style={{"backgroundColor": q1color}} onClick={() => handleQClick(1)}>Путем проведения биопсии<br/>костного мозга</div>
                                    <div className={styles.teachQuestionItem} style={{"backgroundColor": q2color}} onClick={() => handleQClick(2)}>Методом проточной цитометрии</div>
                                    <div className={styles.teachQuestionItem} style={{"backgroundColor": q3color}} onClick={() => handleQClick(3)}>С помощью прямой пробы Кумбса</div>
                                </div>
                            </>
                        }
                        {pages[teachPage].image == `${base}/images/alex_teach_enter_2.png` &&
                            <div className={styles.moveToNext} onClick={handleNextClick}></div>
                        }
                        {pages[teachPage].image == `${base}/images/alex_teach_enter_3.png` &&
                            <div className={styles.moveToPrev} onClick={handlePrevClick}></div>
                        }
                        {pages[teachPage].image == `${base}/images/sergey_teach_enter_2.png` &&
                            <div className={styles.moveToNext} onClick={handleNextClick}></div>
                        }
                        {pages[teachPage].image == `${base}/images/sergey_teach_enter_3.png` &&
                            <div className={styles.moveToPrev} onClick={handlePrevClick}></div>
                        }
                    </div>

                </div>
                {pages.length > 1 && (
                    <div className={styles.analyzeControl}>
                        <img src={`${base}/images/analyze_arrow.svg`} alt="analyze_arrow" onClick={handlePrevClick}/>
                        <img src={`${base}/images/analyze_arrow.svg`} alt="analyze_arrow" onClick={handleNextClick} style={{transform: "rotate(180deg)"}}/>
                    </div>
                )}

            </div>

            <div className={styles.stepButtons}
                 style={{justifyContent: 'center'}}>
                <Button label='Далее' redColor={false} answered={false} onClick={() => {
                    if (teachPage < pages.length - 1) { handleNextClick() } else { onClick() }
                }} width={'262px'}/>
            </div>
        </>
    );
}


export default Teach;
